﻿export class RequestTracker {
    private requestId: number;

    constructor() {
        this.begin();
    }

    increment() {
        this.requestId++;
    }

    current() {
        return this.requestId;
    }

    reset() {
        this.requestId = 0;
    }

    begin() {
        this.requestId = 1;
    }

    vandalize() {
        this.requestId = 402;
    }
}